export const HEIGHT_FOR_AGE_OPTIONS = [
  { label: "เตี้ยแคระแกร็น", value: "severe_stunted" },
  { label: "เตี้ย", value: "stunted" },
  { label: "ค่อนข้างเตี้ย", value: "relatively_stunted" },
  { label: "ตามเกณฑ์", value: "normal" },
  { label: "ค่อนข้างสูง", value: "quite_high" },
  { label: "สูง", value: "high" },
];

export const WEIGHT_FOR_HEIGHT_OPTIONS = [
  { label: "ผอมแห้ง", value: "severe_wasted" },
  { label: "ผอม", value: "wasted" },
  { label: "ค่อนข้างผอม", value: "relatively_wasted" },
  { label: "สมส่วน", value: "normal" },
  { label: "ท้วม", value: "buxom" },
  { label: "เริ่มอ้วน", value: "overweight" },
  { label: "อ้วน", value: "obese" },
];
